import axios from 'axios';

import { paymentData, cartData, queryObj } from '../types';
import { updateCartOnPageReload } from '../store/slices/cartSlice';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default async function displayRazorpay(cartData: cartData, dispatch: any, navigate: any) {
  try {
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    const response: queryObj = await axios.post(
      'https://e-commerce-store-backend-ten.vercel.app/razorpay',
      {
        amount: cartData.productsTotalPrice,
      },
    );
    if (response.errorMessage) {
      return;
    }
    const data = response.data;
    const options = {
      key: 'rzp_test_do09241L3ypr7R',
      currency: data.currency,
      amount: data.amount,
      name: 'Akshay Bandivadekar\'s Store',
      description: 'Wallet Transaction',
      image: 'https://e-commerce-store-backend-ten.vercel.app/logo.png',
      orderId: data.id,
      handler: function (response: paymentData) {
        let queryString = `provider=Razorpay&paymentId=${response.razorpay_payment_id}&userName=${userDetails.name}&userEmail=${userDetails.email}&`;
        Object.entries(data).forEach(([key, value]) => {
          queryString += key + '=' + value + '&';
        });
        queryString = queryString.slice(0, -1);
        dispatch(updateCartOnPageReload([]));
        localStorage.setItem('cartDetails', JSON.stringify([]));
        navigate(`/payment-response?${queryString}`);
      },
      prefill: {
        name: userDetails.name,
        email: userDetails.email,
        contact: '9999999999',
      },
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const paymentObject = new (window as any).Razorpay(options);
    paymentObject.open();
  } catch (error) {
    console.log(error);
  }
}
